import ContextEntity from './contextEntity.js';
class ContextEventStorage {
    static init(useStorage) {
        this.storage = {
            browser: new ContextEntity(useStorage, 'browser'),
            geo: new ContextEntity(useStorage, 'geo'),
            page: new ContextEntity(useStorage, 'page'),
            user: new ContextEntity(useStorage, 'user'),
        };
        this.initialized = true;
    }
    static toJson() {
        return {
            ...(Object.keys(this.storage.browser.contextValue).length > 0 ? { browser: this.storage.browser.toJson() } : {}),
            ...(Object.keys(this.storage.geo.contextValue).length > 0 ? { geo: this.storage.geo.toJson() } : {}),
            ...(Object.keys(this.storage.page.contextValue).length > 0 ? { page: this.storage.page.toJson() } : {}),
            ...(Object.keys(this.storage.user.contextValue).length > 0 ? { user: this.storage.user.toJson() } : {}),
        };
    }
}
Object.defineProperty(ContextEventStorage, "initialized", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: false
});
export default ContextEventStorage;
export const updateEventContextFromContext = (context) => {
    ContextEventStorage.storage.geo.set('ip', context.geo?.ip);
    ContextEventStorage.storage.page.set('uri', context.page?.uri);
    ContextEventStorage.storage.page.set('locale_country', context.locale?.country);
    ContextEventStorage.storage.page.set('locale_language', context.locale?.language);
};
